var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"tabbed-view-tabs"},_vm._l((_vm.tabs),function(tab){return _c('li',{key:tab,class:{ 'is-active': _setup.casedActive === tab },on:{"click":function($event){return _setup.clicked(tab)}}},[_vm._t(_setup.getTabSlotName(tab),function(){return [_c('span',[_vm._v(_vm._s(tab))])]},{"tab":tab})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }